import React, { Component, Fragment } from "react"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import * as reportSelectionActions from "../../state/actions/reportSelectionActions"
import QuestionSelectionModal from "./Modals/QuestionSelectionModal"
import { ReportSelectedOptionsShape, ReviewDataShape } from "../../state/shapes/CustomReportShapes"

class QuestionSelection extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    reviewData: PropTypes.shape(ReviewDataShape),
    setSelectedQuestions: PropTypes.func.isRequired,
    reportSelection: PropTypes.shape(ReportSelectedOptionsShape).isRequired
  }
  static defaultProps = {
    reviewData: null
  }
  state = {
    showModal: false
  }

  updateSelectedTabsAndQuestions = exportTabs => {
    const numberOfQuestionsSelected = exportTabs.reduce((total, item) => {
      if (item.selectedQuestions) {
        const newTotal = total + item.selectedQuestions.length
        return newTotal
      }
      return total
    }, 0)

    this.props.setSelectedQuestions(exportTabs, numberOfQuestionsSelected)
  }

  editClicked = () => {
    this.setState({ showModal: true })
  }

  closePopup = () => {
    this.setState({ showModal: false })
  }

  render() {
    const { t, reviewData, reportSelection } = this.props

    return (
      <Fragment>
        <div className="row form-group">
          <div className="col-lg-5 col-md-5">
            {t("CustomReport.QuestionSelection.SelectText")} *
          </div>
          <div className="col-lg-4 col-md-4" style={{ color: "#999" }}>
            {reportSelection.numberOfSelectedQuestions === 0 ? (
              <span>{t("CustomReport.QuestionSelection.NoneSelected")}</span>
            ) : (
              <span>
                {reportSelection.numberOfSelectedQuestions}{" "}
                {t("CustomReport.QuestionSelection.QuestionsSelected")}
              </span>
            )}
          </div>
          <div className="col-lg-3 col-md-3">
            <button className="btn" onClick={this.editClicked} disabled={!reviewData}>
              {t("CustomReport.Common.Edit")}
            </button>
          </div>
        </div>
        {this.state.showModal ? (
          <QuestionSelectionModal
            closePopup={this.closePopup}
            reviewData={reviewData.workflowSteps}
            updateSelectedQuestions={this.updateSelectedTabsAndQuestions}
            exportDetails={reportSelection.exportDetails}
          />
        ) : null}
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    reportSelection: state.reportSelection
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setSelectedQuestions: (exportTabs, numberOfSelectedQuestions) => {
      dispatch(reportSelectionActions.setSelectedQuestions(exportTabs, numberOfSelectedQuestions))
    }
  }
}

export default compose(translate(), connect(mapStateToProps, mapDispatchToProps))(QuestionSelection)



// WEBPACK FOOTER //
// ./src/components/custom-report/QuestionSelection.jsx